// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as React from "react";
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import {
    Card, CardContent, CardActions, TextField, makeStyles, Chip,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Button, InputBase, Switch,
} from '@material-ui/core';
import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import { apolloClient as client } from "../data-provider/graphqlDataProvider";

var token: any = localStorage.getItem('credentials')
// const client = new ApolloClient({
//     uri: `${process.env.REACT_APP_DATAPROVIDER}`,
//     headers: { authorization: token },
//     cache: new InMemoryCache(),
//     defaultOptions: {
//         watchQuery: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'ignore',
//         },
//         query: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'all',
//         },
//     }
// });

const discountTypes = [
    {
        value: 'LIMOO_CARD',
        label: 'لیموکارت ',
    },

];

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
        width: '100%'
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    table: {
        minWidth: 650,
    }
}));

const productSeleceted = (productDiscount: Array<any>): Array<any> => {
    let result = []
    productDiscount.forEach((pd: any) => {
        if (pd.enable)
            result.push(pd.id)
    })
    return result
}

const getProductFinalPrice = (productDiscount: Array<any>): any => {
    let result = {}
    productDiscount.forEach((pd: any) => {
        if (pd.enable)
            result[pd.id] = 100;
    })
    return result;
}


export function CreateGroupLimooCard() {
    const classes = useStyles();
    const [discountType, setDiscountType] = React.useState('LIMOO_CARD');
    const [allProducts, setAllProducts] = React.useState<Array<any>>([]);
    const [productDiscount, setProductDiscount] = React.useState<Array<any>>([]);
    const [rowsLoading, setRowsLoading] = React.useState(false);
    const [values, setValues] = React.useState({
        eachCodeCountPerUser: null,
        eachCodeTotalCount: null,
        uniqueCodesNum: null,
        startDate: null,
        endDate: null,
        immediateEnabled: true,
        tags: [],
        name: '',
        description: '',
        distributor: { id: '', price: '' },
        marketer: { id: '', price: '' },
        seller: { id: '', price: '' },
        fromSN: null,
        charset: null,
        defaultPrice:null,
    });
    const [status, setStatus] = React.useState({ loading: false, message: '', hasError: false });

    async function getAllProducts() {
        const GET_Products = gql`
        query Products($where: ProductWhereInput) {
            products(where: $where) {
              id
              title
            }
        }
      `;
        let result: Array<any> = await client.query({
            query: GET_Products,
            variables: {
                where: {
                    service: { equals: process.env.REACT_APP_SERVICE },
                    isEnabled: { equals: true }
                },
            }
        }).then((res) => {
            return res.data.products;
        })
        setAllProducts(result);
        let pd = result.map((product: any) => ({ ...product, finalPrice: '', enable: false }))
        setProductDiscount(pd)
        setRowsLoading(true)
    }

    const handleDeleteTag = (chipToDelete) => () => {
        setValues({ ...values, tags: values.tags.filter((tag) => tag.key !== chipToDelete.key) })
    };

    const handleAddTag = (e, newTagLabel) => {
        let existTag = values.tags.some(t => t.key === newTagLabel.toUpperCase())
        if (!existTag && newTagLabel !== "")
            setValues({ ...values, tags: [...values.tags, { key: newTagLabel.toUpperCase(), label: newTagLabel }] })
    }

    const handleDiscountType = (event: any) => {
        console.log('handleDiscountType');
        setDiscountType(event.target.value);
    };

    const handlerEnabled = (productId: any) => {
        console.log('handlerEnabled');
        let result = productDiscount.map((pd: any) => {
            if (pd.id === productId)
                return { ...pd, enable: !pd.enable };
            return pd;
        })
        setProductDiscount(result)
    }

    const startDateHandler = (value: any) => {
        console.log('startDateHandler');
        setValues({ ...values, startDate: value })
    }

    const endDateHandler = (value: any) => {
        console.log('endDateHandler');
        setValues({ ...values, endDate: value })
    }

    const handlerFinalPrice = (value: any, productId: any) => {
        console.log('handlerFinalPrice');
        let result = productDiscount.map((pd: any) => {
            if (pd.id === productId)
                return { ...pd, finalPrice: value };
            return pd;
        })
        setProductDiscount(result)
    }

    const submitDiscount = async () => {
        setStatus({ message: '', loading: true, hasError: false })
        console.log('submitDiscount')

        let data = {
            eachCodeCountPerUser: Number(values.eachCodeCountPerUser),
            eachCodeTotalCount: Number(values.eachCodeTotalCount),
            uniqueCodesNum: Number(values.uniqueCodesNum),
            name: values.name,
            description: values.description,
            discountType: discountType,
            startDate: values.startDate,
            expiryDate: values.endDate,
            immediateEnabled: values.immediateEnabled,
            tags: values.tags.map(tag => tag.label),
            meta: {
                distributor:{id:values.distributor.id,price:Number(values.distributor.price)},
                marketer:{id:values.marketer.id,price:Number(values.marketer.price)},
                seller:{id:values.seller.id,price:Number(values.seller.price)},
                productOptions:getProductFinalPrice(productDiscount),
                defaultPrice:Number(values.defaultPrice),
            },
            fromSN:Number(values.fromSN),
            charset:values.charset,
        }
        console.log('data request: ', data)

        await axiosWithAuthInterceptor({
            url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/discounts/bulk`,
            method: 'POST',
            data: { ...data },
        }).then(res => {
            if (!res.data.err) {
                setStatus({ loading: false, message: 'با موفقیت ثبت شد', hasError: false })
                window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/Discount`
            }
            else
                setStatus({ loading: false, message: 'خطا در ثبت!', hasError: true })
        }).catch(e => {
            console.log('error catch: ', e)
            setStatus({ loading: false, message: 'خطا در ثبت!', hasError: true })
        })
    }

    React.useEffect(() => {
        getAllProducts();
    }, [])

    return (
        <Card>
            <CardContent>
                <div style={{ display: "flex", flexDirection: 'column', marginBottom: '1rem' }}>
                    <div style={{ display: "flex", flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                        <TextField
                            fullWidth
                            label="نوع تخفیف"
                            size="medium"
                            disabled
                            id="outlined-select-currency-native"
                            select
                            onChange={(e: any) => handleDiscountType()}
                            variant="outlined"
                            value={discountType}
                        >
                            {discountTypes.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </TextField>
                        <TextField fullWidth onChange={(e: any) => setValues({ ...values, name: e.target.value })} value={values.name} size="medium" label="نام" variant="outlined"></TextField>
                    </div>
                    <div style={{ display: "flex", flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                        <TextField fullWidth multiline rows={3} onChange={(e: any) => setValues({ ...values, description: e.target.value })} value={values.description} size="medium" label="توضیحات" variant="outlined"></TextField>
                    </div>
                    <div style={{ display: "flex", flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                        <TextField fullWidth onChange={(e: any) => setValues({ ...values, eachCodeCountPerUser: e.target.value })} value={values.eachCodeCountPerUser} label="تعداد برای هر کاربر" size="medium" type="number" variant="outlined"></TextField>
                        <TextField fullWidth onChange={(e: any) => setValues({ ...values, eachCodeTotalCount: e.target.value })} value={values.eachCodeTotalCount} label="تعداد کل" size="medium" type="number" variant="outlined"></TextField>
                        <TextField fullWidth onChange={(e: any) => setValues({ ...values, uniqueCodesNum: e.target.value })} value={values.uniqueCodesNum} label="تعداد کد ایجاد شده" size="medium" type="number" variant="outlined"></TextField>
                    </div>

                    <div style={{ display: "flex", flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                    <TextField fullWidth onChange={(e: any) => setValues({ ...values, fromSN: e.target.value })} value={values.fromSN} label="از لیموکارت   " size="medium" type="number" variant="outlined"></TextField>  
                    <TextField fullWidth onChange={(e: any) => setValues({ ...values, charset: e.target.value })} value={values.charset} label="چارست    " size="medium" type="string" variant="outlined"></TextField>
                    <TextField fullWidth onChange={(e: any) => setValues({ ...values, defaultPrice: e.target.value })} value={values.defaultPrice} label="قیمت پایه    " size="medium" type="number" variant="outlined"></TextField>
                    </div>
                    <div style={{ display: "flex", flexDirection: 'row-reverse',  alignItems: 'center', marginBottom: '1rem',gap:"1rem", justifyContent: 'space-between' }}>
                    <div style={{display:'flex', width:"100%",flexDirection:'column', gap:"1rem"}}>
                    <TextField fullWidth onChange={(e: any) => setValues({ ...values, distributor: { ...values.distributor, id: e.target.value } })} value={values.distributor.id} label="آیدی توزیع کننده" size="medium" type="string" variant="outlined"></TextField>  
                    <TextField fullWidth onChange={(e: any) => setValues({ ...values, distributor: { ...values.distributor, price: e.target.value } })} value={values.distributor.price} label="قیمت توزیع کننده" size="medium" type="number" variant="outlined"></TextField>  
                    </div>  
                    <div style={{display:'flex', width:"100%",flexDirection:'column', gap:"1rem"}}>
                    <TextField fullWidth onChange={(e: any) => setValues({ ...values, marketer: { ...values.marketer, id: e.target.value } })} value={values.marketer.id} label="آیدی  بازاریاب" size="medium" type="string" variant="outlined"></TextField>  
                    <TextField fullWidth onChange={(e: any) => setValues({ ...values, marketer: { ...values.marketer, price: e.target.value } })} value={values.marketer.price} label="قیمت  بازاریاب" size="medium" type="number" variant="outlined"></TextField>  
                    </div> 
                    <div style={{display:'flex', width:"100%",flexDirection:'column', gap:"1rem"}}>
                    <TextField fullWidth onChange={(e: any) => setValues({ ...values, seller: { ...values.seller, id: e.target.value } })} value={values.seller.id} label="آیدی  فروشنده" size="medium" type="string" variant="outlined"></TextField>  
                    <TextField fullWidth onChange={(e: any) => setValues({ ...values, seller: { ...values.seller, price: e.target.value } })} value={values.seller.price} label="قیمت  فروشنده" size="medium" type="number" variant="outlined"></TextField>  
                    </div>   
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center', marginBottom: '1rem' }}>
                        <div className={classes.root}>
                            {values.tags?.map((data) => {
                                return (
                                    <li key={data.key}>
                                        <Chip
                                            label={data.label}
                                            onDelete={handleDeleteTag(data)}
                                            className={classes.chip}
                                            variant="outlined"
                                        />
                                    </li>
                                );
                            })}

                        </div>
                        <TextField fullWidth onBlur={(e) => handleAddTag(e, e.target.value)} size="medium" label="تگ" variant="outlined"></TextField>
                    </div>
                    <div style={{ display: "flex", flexDirection: 'row', gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                        <TextField
                            fullWidth
                            onChange={(e: any) => startDateHandler(e.target.value)}
                            label="تاریخ شروع"
                            value={values.startDate}
                            size="medium"
                            id="todate"
                            type="date"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />

                        <TextField
                            fullWidth
                            onChange={(e: any) => endDateHandler(e.target.value)}
                            label="تاریخ پایان"
                            value={values.endDate}
                            size="medium"
                            id="todate"
                            type="date"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <Switch
                                checked={values.immediateEnabled}
                                onChange={(e: any) => setValues({ ...values, immediateEnabled: !values.immediateEnabled })}
                                color="primary"
                                name="checkedA"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                        </div>
                    </div>
                </div>
                {
                    rowsLoading ?
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ fontWeight: 700 }} align="center">محصول</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">شناسه</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">فعال/غیرفعال</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">مبلغ نهایی</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {productDiscount.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell align="center">{row.title}</TableCell>
                                            <TableCell align="center">{row.id}</TableCell>
                                            <TableCell align="center">
                                                <Switch
                                                    checked={row.enable}
                                                    onChange={(e: any) => handlerEnabled(row.id)}
                                                    color="primary"
                                                    name="checkedA"
                                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                />
                                            </TableCell>
                                            <TableCell align="center">
                                                <InputBase
                                                    value={row.finalPrice}
                                                    onChange={(e: any) => handlerFinalPrice(e.target.value, row.id)}
                                                    disabled={!row.enable}
                                                    style={{ textAlign: 'center' }}
                                                    placeholder="مبلغ نهایی را وارد کنید"
                                                />
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer> :
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5rem' }}>
                            <CircularProgress />
                        </div>
                }
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '2rem', justifyContent: 'space-between' }}>
                    <Button onClick={() => submitDiscount()} variant="contained" color="primary" style={{ color: '#fff' }}>
                        {
                            !status.loading ? 'ثبت' :
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '25px', height: '25px' }}>
                                    <CircularProgress size={25} color="#fff" />
                                </div>
                        }
                    </Button>
                    {
                        !status.loading && status.hasError && status.message ?
                            <section style={{ display: 'flex', backgroundColor: 'red', color: '#fff', padding: '5px', borderRadius: '8px', fontFamily: 'IranSans-Bold', fontSize: '14px', direction: 'rtl' }}>
                                {status.message}
                            </section>
                            :
                            <div></div>
                    }
                    {
                        !status.loading && !status.hasError && status.message ?
                            <section style={{ display: 'flex', backgroundColor: '#4fcc12', color: '#fff', padding: '5px', borderRadius: '8px', fontFamily: 'IranSans-Bold', fontSize: '14px', direction: 'rtl' }}>
                                {status.message}
                            </section>
                            :
                            <div></div>
                    }

                </div>
            </CardContent>
            <CardActions>

            </CardActions>
        </Card >
    )
}